import { createSelector } from 'reselect'
import entryDataSelector from './entryDataSelector'

const dgaDealerIdSelector = createSelector(
    entryDataSelector,
    (entryData): string => entryData?.additional.find(el => el.id === "dgaDealerId")?.value || '',
)

export default dgaDealerIdSelector
